module.exports = function() {
  return new Worker(__webpack_public_path__ + "2c73a641746870e31321.worker.js");
};